import styled from 'styled-components';

import { TextInput } from '@sternum/ui';
import { Icon } from '@sternum/web/components';

export const IconStyled = styled(Icon)`
  margin-left: 12px;
`;

export const InputStyled = styled(TextInput)`
  padding-left: 38px;
  padding-right: 24px;
`;
